<template>
    <header class="header header--systems" :class="{ 'header--tabbarnavigation': tabBar }">
        <div class="row">
            <div class="column-tablet-16">
                <h1 class="header__headline color-accent">{{ text }}</h1>
            </div>
            <div v-if="button && button.ability" class="column-tablet-8 align-right slab-zero--small--top">
                <a @click="$emit(button.emitEvent)" class="header__button button button--primary">
                    <i v-if="button.loading !== undefined" class="icon icon--common-spinner spinner" :class="{ 'spinner--finished': !button.loading }"></i>
                    <i v-if="icon != ''" class="icon icon--normal slab-zero--dwarf--right" :class="`icon--${icon} ${iconClass}`"></i>
                    {{ button.text }}
                </a>
            </div>
            <div v-if="searchField" class="column-tablet-8 align-right slab-zero--small--top">
                <FieldSearch
                    ref="fieldSearch"
                    @search="$emit(searchField.inputEmitEvent, $event)"
                    :placeholder="searchField.placeholder"
                    :allowedFields="searchField.allowedFields"
                    :defaultField="searchField.defaultField ? searchField.defaultField : 'name'"
                    :nameTranslation="searchField.nameTranslation"
                    :savedSearchName="searchField.savedSearchName"
                    :simpleSearch="searchField.simpleSearch"
                />
            </div>
        </div>

        <div v-if="tabBar && systemManagementLinks" class="header__tabbarnavigation hide-until-wrapper">
            <swiper-container class="header__tabbarnavigation__slider js-tabbar-slider" init="false" ref="tabSliderEl">
                <swiper-slide v-for="link in systemManagementLinks" :key="link.label">
                    <router-link :to="link.to" :class="{ active: link.isActive }">
                        {{ link.label }}
                    </router-link>
                </swiper-slide>
            </swiper-container>
        </div>
    </header>
</template>

<script>
import { mapState } from 'vuex';
import FieldSearch from '@/components/FieldSearch';
import generalLinks from '@/mixins/generalLinks';

export default {
    name: 'page-header',
    components: {
        FieldSearch,
    },
    mixins: [generalLinks],
    props: {
        text: String,
        button: {
            default: false,
        },
        icon: {
            type: String,
            default: '',
        },
        iconClass: {
            type: String,
            default: '',
        },
        searchField: {
            type: [Boolean, Object],
            default: false,
        },
        tabBar: {
            type: [Boolean, Object],
            default: false,
        },
    },
    data() {
        return {
            searchInput: '',
        };
    },
    computed: {
        ...mapState(['activeSystem']),
    },
    mounted() {
        this.initSlider();
    },
    methods: {
        setInitialSearchValue(value) {
            this.$refs.fieldSearch.setInitialSearchValue(value);
        },
        clearSearchField() {
            this.$refs.fieldSearch.clear();
        },
        initSlider() {
            const swiperEl = this.$refs['tabSliderEl'];

            if (swiperEl) {
                const initialSlideIndex = this.systemManagementLinks.findIndex(link => link.isActive);

                const swiperParams = {
                    initialSlide: initialSlideIndex || 0,
                    slidesPerView: 1.5,
                    breakpoints: {
                        480: {
                            slidesPerView: 1.8,
                        },
                        768: {
                            slidesPerView: 2.5,
                        },
                        1024: {
                            slidesPerView: 4,
                        },
                    },
                };
                Object.assign(swiperEl, swiperParams);
                swiperEl.initialize();
            }
        },
    },
};
</script>

<style lang="scss">
.header {
    $tabbar-height-desktop: 65px;
    $tabbar-height-mobile: 45px;
    padding: 75px 25px 20px 55px;

    background-image: url(../images/header-home.jpg);
    background-repeat: no-repeat;
    background-position: left center;
    background-size: cover;

    @include mq($until: tablet) {
        padding: 60px $page-padding-small 20px $page-padding-small;
    }

    @include mq($until: wrapper) {
        padding-left: $page-padding-small;
    }

    &--tabbarnavigation {
        position: relative;

        @include mq(wrapper) {
            padding-bottom: calc(#{$tabbar-height-desktop} + 20px);
        }
    }

    &--systems {
        background-image: url(../images/header-systems.jpg);
    }

    &__lead {
        max-width: 550px;
        margin-bottom: 40px;

        color: white;
    }

    &__button {
        @include mq($until: mobile-landscape) {
            width: 100%;
        }
    }

    &__tabbarnavigation {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        display: flex;
        background: white;
        border-bottom: solid 1px rgba(0, 0, 0, 0.3);
        height: $tabbar-height-desktop;

        @include mq($until: tablet) {
            height: $tabbar-height-mobile;
        }

        &__slider {
            width: 100%;
        }

        a {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            text-align: center;
            background: $color-gray-light;
            font-weight: normal;
            padding: 15px;
            color: $text-color;
            transition: all 0.25s ease;
            font-size: 18px;
            height: 100%;

            @include mq($until: wrapper) {
                font-size: 16px;
            }

            @media (hover: hover) {
                &:hover {
                    background: $color-gray-mid;
                }
            }
            &.active {
                background: $color-gray-dark;
                color: white;
                cursor: default;
            }
        }
    }
}
</style>
